/** THIS FILE IS AUTOGENERATED. DO NOT EDIT. */
import { IconProps } from "../types";
const ArrowDownRightIcon = ({
  size = 24,
  ...props
}: IconProps) => {
  return <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width={size} height={size} {...props}><path fillRule="evenodd" d="M3.793 3.793a1 1 0 0 1 1.414 0L18.5 17.086V8.25a1 1 0 1 1 2 0V19.5a1 1 0 0 1-1 1H8.25a1 1 0 1 1 0-2h8.836L3.793 5.207a1 1 0 0 1 0-1.414" clipRule="evenodd" /></svg>;
};
export default ArrowDownRightIcon;